import { render, staticRenderFns } from "./Nominees.vue?vue&type=template&id=2ad51851&scoped=true"
import script from "./Nominees.vue?vue&type=script&lang=js"
export * from "./Nominees.vue?vue&type=script&lang=js"
import style0 from "./Nominees.vue?vue&type=style&index=0&id=2ad51851&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad51851",
  null
  
)

export default component.exports